import { POReceivingListPage } from "@/features/po-receiving/pages/POReceivingListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/receiving/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["receiving.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: POReceivingListPage,
});
